export default "<h3>Subscription Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"